const invite = {
  state: {
    flag: false
  }
}

export default invite
